// @flow
import React from 'react';
import { I18n } from '@lingui/react';
import { t } from '@lingui/macro';

import { MQ, Spacing } from '@rover/react-lib/styles';
import styled, { type StyledComponent } from 'styled-components';

import TextInput, { type Props as TextInputProps } from '../../formFields/TextInput';

type Props = {
  ...TextInputProps,
  isUS: boolean,
};

const StyledTextInput: StyledComponent<React$ElementConfig<typeof TextInput>, {}, any> = styled(
  TextInput
)`
  flex: 1;
  margin-left: ${Spacing.M};

  ${MQ.XS} {
    width: 100%;
    flex: none;
    margin-left: 0;
  }
`;

const AddressFormLine2Field = ({ isUS, ...other }: Props) => {
  const label = isUS ? t`Apt., Ste., Bldg. (Optional)` : t`Address Line 2`;

  return (
    <I18n>
      {({ i18n }) => (
        <StyledTextInput
          sensitive
          label={i18n._(label)}
          name="address-line2"
          placeholder={i18n._(label)}
          autoComplete="address-line2"
          data-qa-id="input-text-address-line-2"
          {...other}
        />
      )}
    </I18n>
  );
};

export default AddressFormLine2Field;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/AddressForm/AddressFormLine2Field.jsx